










































































































































































































































































































































































import { Settings, TenantSettings } from "@/shared/core/services/configService";
import {
  Component,
  Vue,
  Watch,
} from "@/shared/node_modules/vue-property-decorator";

import VueGallery from "@/shared/node_modules/vue-gallery";
import { CrudService } from "@/shared/core/services/crudService";
import LoginRegisterDialog from "@/shared/components/login/loginRegisterDialog.vue";
import { LocalStorage } from "@/shared/core/localStorage";
import store from "@/shared/core/store";
import MenuShopCart from "@/shared/components/menuShopCart/menuShopCart.vue";
// import MenuSearch from "@/shared/components/menuSearch/menuSearch.vue";
import IconPillButton from "@/shared/components/iconPillButton/iconPillButton.vue";
import IconMenu from "@/shared/components/icons/IconMenu.vue";
import BrandLogo from "@/shared/components/icons/BrandLogo.vue";
import IconUsers from "@/shared/components/icons/IconUsers.vue";
import AccountMenu from "@/shared/components/accountMenu/accountMenu.vue";
import "../js/rdnavbar.js";
import "../js/script.js";

@Component({
  components: {
    VueGallery,
    LoginRegisterDialog,
    MenuShopCart,
    // MenuSearch,
    IconPillButton,
    IconMenu,
    BrandLogo,
    IconUsers,
    AccountMenu,
  },
})
export default class CzMenu extends Vue {
  settings: TenantSettings = {};
  logoUrl: string | null = null;
  images: any[] = [];
  index: any = null;
  posts: any[] = [];
  hasShopItems: boolean = false;
  hasPrograms: boolean = false;
  hasBlog: boolean = false;
  hasCourses: boolean = false;
  currentLanguage: string = "";
  userMenuOpen: boolean = false;
  langMenuOpen: boolean = false;
  languageOptions = [
    { value: "en-US", label: "English", short: "EN" },
    { value: "es-ES", label: "Español", short: "ES" },
  ];
  get isHome() {
    const path = this.$route ? this.$route.path : "";
    return path === "/" || path.startsWith("/bookings-byplace");
  }

  get isLoggedIn() {
    return store.state.loggedIn === true;
  }

  get currentLanguageShort() {
    const match = this.languageOptions.find(
      (option) => option.value === this.currentLanguage
    );
    if (match) {
      return match.short;
    }
    return (this.currentLanguage || "en").split("-")[0].toUpperCase();
  }

  async mounted() {
    const storedLanguage = LocalStorage.get("lcl");
    this.currentLanguage =
      storedLanguage === null || storedLanguage === undefined
        ? "es-ES"
        : storedLanguage;
    this.settings = store.state.settings;

    if (this.settings.Mainlogo !== null) {
      this.logoUrl = this.settings.Uploads + "/" + this.settings.Mainlogo;
    }

    await this.loadPosts();
    await this.loadShopAvailability();
    await this.loadProgramsAvailability();
    await this.loadCoursesAvailability();
    await this.loadGallery();
    this.$nextTick(() => this.scrollToHash(this.$route.hash));
  }

  async loadPosts() {
    const url = `${Settings.HostName}/api/cztextblocks/list-with-users?count=2`;

    const data = await new CrudService().httpGet(url);
    if (data == null) {
      console.error("Crash getting last posts");
      return;
    }
    this.posts = data;
    this.hasBlog = Array.isArray(this.posts) && this.posts.length > 0;
  }

  async loadShopAvailability() {
    if (
      this.settings === null ||
      this.settings === undefined ||
      this.settings.HasShop !== true
    ) {
      this.hasShopItems = false;
      return;
    }
    const url = `${Settings.HostName}/api/shop/list?startRow=0&endRow=1`;
    const data = await new CrudService().httpGet(url);
    if (data == null || data.ok === false || data.Ok === false) {
      console.error("Crash getting shop availability");
      this.hasShopItems = false;
      return;
    }
    const items = data.data || data.Data || [];
    const totalCount =
      data.totalCount !== undefined && data.totalCount !== null
        ? data.totalCount
        : data.TotalCount;
    if (typeof totalCount === "number") {
      this.hasShopItems = totalCount > 0;
      return;
    }
    this.hasShopItems = Array.isArray(items) && items.length > 0;
  }

  async loadProgramsAvailability() {
    const url = `${Settings.HostName}/api/publicprogrampacks/list`;
    const data = await new CrudService().httpGet(url);
    this.hasPrograms = data != null && data.ok === true && data.data.length > 0;
  }

  async loadCoursesAvailability() {
    const url = `${Settings.HostName}/api/public-courses/has-courses`;
    const data = await new CrudService().httpGet(url);
    if (data == null || data.ok === false) {
      this.hasCourses = false;
      return;
    }
    this.hasCourses = data.totalCount > 0;
  }

  getImage(name: string) {
    if (name !== undefined && name !== "" && name !== null) {
      return this.settings.Uploads + "/" + name;
    }
    return this.settings.Uploads + "/" + this.settings.Mainlogo;
  }

  selectLanguage(language: string) {
    this.currentLanguage = language;
    LocalStorage.add("lcl", language);
    this.closeMenus();
    this.$router.go(0);
  }

  isLanguageActive(language: string) {
    return this.currentLanguage === language;
  }

  toggleUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
    if (this.userMenuOpen) {
      this.langMenuOpen = false;
    }
  }

  toggleLangMenu() {
    this.langMenuOpen = !this.langMenuOpen;
    if (this.langMenuOpen) {
      this.userMenuOpen = false;
    }
  }

  closeUserMenu() {
    this.userMenuOpen = false;
  }

  closeLangMenu() {
    this.langMenuOpen = false;
  }

  closeMenus() {
    this.userMenuOpen = false;
    this.langMenuOpen = false;
  }

  closeMobileAccount() {
    this.toggleMenu();
  }

  async loadGallery() {
    const dbGallery = localStorage.getItem(Settings.Prefix + "all-gallery");
    if (Vue.prototype.$last !== "/" && dbGallery !== null) {
      this.images = JSON.parse(dbGallery).map((y) => y.url);
      return;
    }

    const url = `${Settings.HostName}/api/fileuploads/open-list?parentName=CZConfig&parentId=1&category=CzGallery`;
    const data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash getting cz gallery");
      return;
    }

    for (const image of data.data) {
      image.url = this.settings.Uploads + "/CzConfig/CzGallery/" + image.url;
      this.images.push(image.url);
    }

    localStorage.setItem(
      Settings.Prefix + "all-gallery",
      JSON.stringify(data.data)
    );
  }

  @Watch("$route.fullPath")
  toggleMenu() {
    const button: any = this.$refs.toggleButton;
    const menu: any = this.$refs.toggleMenu;
    const buttonEl: any = button && button.$el ? button.$el : button;
    if (!buttonEl.classList.contains("active")) {
      return;
    }

    buttonEl.classList.remove("active");
    menu.classList.remove("active");
  }

  @Watch("$route.hash")
  routeHashChanged(hash: string) {
    this.scrollToHash(hash);
  }

  scrollToHash(hash: string) {
    if (hash === null || hash === undefined || hash === "" || hash === "#") {
      return;
    }
    const id = hash.startsWith("#") ? hash.slice(1) : hash;
    const attempt = () => {
      const el = document.getElementById(id);
      if (!el) return false;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return true;
    };
    if (attempt()) return;
    setTimeout(() => {
      attempt();
    }, 150);
    setTimeout(() => {
      attempt();
    }, 600);
  }
}
